import styled from "@emotion/styled";
import { theme } from "theme";

export const SelectField = styled.div`
  .MuiFormControl-root {
    .MuiInputLabel-root {
      font-weight: 500;
    }
    
    .MuiOutlinedInput-root {
      transition: all 0.2s ease-in-out;
      
      &:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }
      
      &.Mui-focused {
        box-shadow: 0 4px 12px rgba(129, 159, 179, 0.25);
      }
      
      @media (max-width: 768px) {
        min-height: 56px;
      }
    }
    
    .MuiSelect-select {
      padding: ${theme.spacing(2)};
      
      @media (max-width: 768px) {
        padding: 16px 14px;
        font-size: 1rem;
        min-height: 56px;
      }
    }
  }
  
  .MuiMenuItem-root {
    padding: ${theme.spacing(1.5)} ${theme.spacing(2)};
    font-size: 0.95rem;
    
    @media (max-width: 768px) {
      padding: ${theme.spacing(1.2)} ${theme.spacing(1.5)};
      font-size: 1rem;
    }
    
    &:hover {
      background-color: ${theme.palette.primary.light}20;
    }
  }
`;
